import classNames from "classnames";

const STATE_CLASS_NAME_BY_VALUE = {
  completed: "oral-interview-state-card--completed",
  idle: "oral-interview-state-card--idle",
  paused: "oral-interview-state-card--paused"
};

const InterviewStateCard = ({ state, children, className }) => {
  const cardClassName = classNames(
    "oral-interview-state-card",
    className,
    STATE_CLASS_NAME_BY_VALUE[state]
  );

  return <div className={cardClassName}>{children}</div>;
};

export default InterviewStateCard;
